import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import ActionPayment from "./ActionPayment";
import is_money from "../../helpers/is_money";

const OtherServices = () => {
  const { 
    data, 
    isLoading, 
    error 
  } = useQuery({
    queryKey: ["OtherServices"],
    queryFn: async () => {
      const response = await axiosget(`ms_transactions/other/payments`);
      return response?.data;
    },
  });

  const renderPaymentCards = () => {
    if (!data || data?.type !== undefined) return null;

    return (
      <div className="payment-grid">
        {data?.map((payment, index) => (
          <div 
            className={`payment-card ${payment?.status ? "active" : "inactive"}`}
            key={`payment-card-${index}`}
            style={{ '--delay': index * 0.1 + 's' }}
          >
            <div className="card-glow"></div>
            <div className="card-content">
              <div className="card-header">
                <h3 className="programme-code">{payment?.purpose}</h3>
                <div className={`status-badge ${payment?.status ? "active" : "inactive"}`}>
                  {payment?.status ? "PAID" : "NOT PAID"}
                </div>
              </div>
              
              <h4 className="programme-name">{payment?.programme?.name}</h4>
              
              <div className="card-details">
                <div className="detail-row">
                  <span className="detail-label">Level:</span>
                  <span className="detail-value">
                    {payment?.level}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Semester:</span>
                  <span className="detail-value">
                    {payment?.semester}
                  </span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Payment Status:</span>
                  <span className={`detail-value ${payment?.status ? "success" : "danger"}`}>
                    {payment?.status ? "✓ Paid" : "✗ Not Paid"}
                  </span>
                </div>

                <div className="detail-row">
                  <span className="detail-label">Amount:</span>
                  <span className={`detail-value ${payment?.status ? "success" : "danger"}`}>
                    {is_money(payment?.amount)}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Remita RRR:</span>
                  <span className={`detail-value ${payment?.status ? "success" : "danger"}`}>
                    {payment?.rrr}
                  </span>
                </div>
              </div>
              <div className="card-footer">
                <ActionPayment v={payment} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="payment-container">
      <PageTitle 
        title="OTHER PAYMENTS PORTAL" 
        sub="Your Other Payment History" 
      />
      
      {isLoading && (
        <div className="loading-overlay">
          <Loader />
          <div className="loading-text">Fetching your records...</div>
        </div>
      )}
      
      {error && (
        <ErrorResponse 
          type="danger" 
          message={`Connection error: ${error.message}`} 
        />
      )}
      
      {data?.type !== undefined && (
        <ErrorResponse 
          type="danger" 
          message={data?.message || "Server processing error"} 
        />
      )}
      
      {data?.type === undefined && data?.wallet <= 0 && (
        <ErrorResponse 
          type="warning" 
          title="FUNDS REQUIRED"
          message="Your education wallet needs attention. Please deposit funds to continue." 
          icon="💰"
        />
      )}
      
      {renderPaymentCards()}
    </div>
  );
};

export default OtherServices;